import { createResource } from 'redux-rest-resource';
import {
  HEADERS as headers,
  CAMPAIGN_MESSAGES_URL,
} from '../../Constants';
import { transformFetchResponse as transformResponse } from '../../Helpers';

export const { types, actions, reducers } = createResource({
  name: 'campaignMessage',
  url: `${CAMPAIGN_MESSAGES_URL}/:id`,
  headers,
  actions: {
    fetch: {
      transformResponse,
    },
  },
});
